<template>
  <transition enter-active-class="uk-animation-fade">
    <nav class="uk-navbar-container" uk-navbar>
      <div class="uk-navbar-center">
        <ul class="uk-navbar-nav">
          <li :class="{ active: $route.name == 'ListContact' }">
            <router-link :to="{ name: 'ListContact' }">
              <span uk-icon="icon:  user; ratio: 2.0"></span>
            </router-link>
          </li>
          <li :class="{ active: $route.name == 'ListChat' }">
            <router-link :to="{ name: 'ListChat' }">
              <span uk-icon="icon:   comment; ratio: 2.0"></span>
              <span class="badge" v-show="msgCount != 0">{{ msgCount }}</span>
            </router-link>
          </li>
          <li
            class="nav-new-cust"
            :class="newCustomerClass"
            @click="getNextCustomer"
          >
            <a>
              <i class="fas fa-comment-alt fa-2x"></i>
              <span class="new-customer-badge">&nbsp;New</span>
            </a>
          </li>
        </ul>
      </div>
    </nav>
  </transition>
</template>

<script>
import { mapGetters } from 'vuex';
import { MenuItem, MenuItemGroup } from 'element-ui';

let checkNewCustomerInterval = undefined;

export default {
  name: 'Sidebarmobile',
  data() {
    return {
      newCustomerClass: { newCust: false, newCustActive: false },
    };
  },
  computed: {
    ...mapGetters('profile', ['profile', 'status']),
    ...mapGetters('chat', ['msgCount', 'msgCountNotHold']),
  },
  components: {
    [MenuItem.name]: MenuItem,
    [MenuItemGroup.name]: MenuItemGroup,
  },
  methods: {
    async getNextCustomer() {
      if (this.$store.state.chat.hasNewCustomer == false) {
        return;
      }
      const handleNoReplyCustomerCount = await this.$store.dispatch(
        'chat/getHandleNoReplyCustomerCount',
      );

      await this.$store.dispatch('chat/getNextNewCustomerUnread'); // refesh list.
      const vm = this;
      function alertReply(customers) {
        vm.$message({
          type: 'warning',
          dangerouslyUseHTMLString: true,
          duration: 5000,
          iconClass: 'el-icon-info',
          message: `<p style="color: #ff0000; font-weight: bold;">กรุณาตอบกลับลูกค้า ก่อนรับลูกค้าใหม่</p>${
            customers
              ? `<ul style="margin: 14px 4px; list-style: none;">${customers.map(
                  c =>
                    `<li style="color: #090909;">${
                      c.customerImage
                        ? `<img style="border-radius: 50%; margin-right: 8px;" load="lazy" src="${c.customerImage}" width="32" height="32" />`
                        : ''
                    }
                    ${c.displayName || c.customerDisplayName}</li>`,
                )}</ul>`
              : ''
          }`,
        });
      }

      // // เช็คเงื่อนไขที่กดรับลูกค้าไม่ได้
      // // ถ้า filter ลูกค้าตัวเองจะเช็ค msgcount ก่อน
      // if (
      //   this.$store.state.chat.customerSelf == true &&
      //   this.msgCountNotHold > handleNoReplyCustomerCount
      // ) {
      //   // this.needCheckMessage = true;
      //   alertReply();
      //   return;
      // }
      // ไม่เช็ค msgCount แล้ว ให้ alert list customer ทุก case

      // ถ้าเป็นลูกค้าทั้งหมดจะ load ข้อมูลมาเช็ค
      const selfCustomerNoReply = await this.$store.dispatch(
        'chat/getSelfCustomerNoReply',
      );
      if (selfCustomerNoReply.length > handleNoReplyCustomerCount) {
        // this.needCheckMessage = true;
        alertReply(selfCustomerNoReply.map(sc => sc.customer));
        return;
      }

      if (this.$route.name !== 'ListChat') {
        this.$store.commit('chat/pushNextCustomerOnLoad', true);
        this.$router.push({ name: 'ListChat' });
      } else {
        await this.$store.dispatch('chat/pushNextCustomerToChatList');
      }
    },
  },
  created() {
    var profile = {
      reservationId: this.profile.reservationId,
      nickname: this.profile.nickName,
      sex: this.profile.sex,
    };
    this.$store.dispatch('chat/setMessageSuggest', profile);
    const vm = this;
    this.$store.dispatch('chat/getNextNewCustomerUnread').then(function() {
      if (vm.$store.state.chat.newCustomerList.length > 0) {
        vm.$store.commit('chat/hasNewCustomer', true); // set ค่าได้จากการ created เท่านั้น ไม่งั้นจะติด loop watch
      }
    });
  },
  watch: {
    '$store.state.chat.hasNewCustomer': function(newValue) {
      this.newCustomerClass = { newCust: newValue, newCustActive: newValue };
    },
  },
  mounted() {
    const vm = this;
    checkNewCustomerInterval = setInterval(async function() {
      await vm.$store.dispatch('chat/getNextNewCustomerUnread');
      if (vm.$store.state.chat.newCustomerList.length > 0) {
        vm.$store.commit('chat/hasNewCustomer', true);
      }
    }, 60000);
    setTimeout(async function() {
      await vm.$store.dispatch('chat/getNextNewCustomerUnread');
      if (vm.$store.state.chat.newCustomerList.length > 0) {
        vm.$store.commit('chat/hasNewCustomer', true);
      }
    }, 5000);
  },
  beforeDestroy() {
    if (checkNewCustomerInterval) {
      clearInterval(checkNewCustomerInterval);
    }
  },
};
</script>

<style scoped>
.uk-navbar-container {
  background: #00978b;
}
ul.uk-navbar-nav li a,
ul.uk-navbar-nav li.active a {
  width: 200px;
}
ul.uk-navbar-nav li a {
  color: #c0c4cc;
}
ul.uk-navbar-nav li.active a {
  color: white;
}
ul.uk-navbar-nav li span.badge,
ul.uk-navbar-nav li.active span.badge {
  background: red;
  position: absolute;
  float: right;
  display: block;
  margin-left: 22px;
}
.nav-new-cust {
  display: block;
  position: relative;
  font-size: 22px;
}
.nav-new-cust svg {
  color: #80ada9;
}
.new-customer-badge {
  font-weight: bold;
  transform: translateY(-10px);
}
.nav-new-cust .new-customer-badge {
  color: #80ada9;
}
.newCustActive .new-customer-badge {
  color: #ff0000;
}
.newCustActive svg {
  color: #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/components/SidebarMobile.vue